import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { ChevronLink } from '@bibliocommons/base-links';

import { ExpandableList } from 'app/components/shared/Expandable';
import { onlineResourceShape } from 'app/shapes/bibPage';
import holdingShape from 'app/shapes/holdingShape';

import './ResourcesList.scss';

function renderResourceLink(resourceLink, handleClick) {
  const uri = resourceLink.get('uri');
  const title = resourceLink.get('title');
  return (
    <div className="resource-link">
      <ChevronLink dataKey="resource-link" href={uri} target="_blank" handleClick={() => handleClick({ title, uri })}>
        {resourceLink.get('title') || <FormattedMessage id="access_online_resource" />}
      </ChevronLink>
    </div>
  );
}

export default function ResourcesList({ resources, collapseCount = 3, handleClick }) {
  const resourceLinks = resources.flatMap(resource => {
    const resourceId = resource.get('id');
    const title = resource.get('title') || resource.get('description') || resource.get('appliesToResourcePart');
    const uris = resource.get('uris') || resource.get('resourceURIs');
    return uris.map(uri => Immutable.Map({ uri, title, key: `${resourceId}-${uri}` }));
  });

  return (
    <ExpandableList
      className="cp-resources-list"
      expandLinkHref="#show-more-resources"
      collapseCount={collapseCount}
      getItemKey={resourceLink => resourceLink.get('key')}
      renderItem={resourceLink => renderResourceLink(resourceLink, handleClick)}
      itemClassName="resource-item"
      list={resourceLinks}
      textKey="resources"
      stacked
    />
  );
}

ResourcesList.propTypes = {
  collapseCount: PropTypes.number,
  handleClick: PropTypes.func.isRequired,
  resources: ImmutablePropTypes.listOf(PropTypes.oneOfType([holdingShape, onlineResourceShape])).isRequired
};
